/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import {
  CompanyContainer,
  HeaderTitle,
  IconButton,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
} from '../../../services/settings/appStyle/global.style';

import {
  Table,
  IconButton as IconButtonWithText,
  Loader,
  DeleteConfirmationModal,
} from '../../../Components/uielements';

import moment from 'moment';
import { IntlMessages } from '../../../helper/langHelper';
import { DeleteIcon, EyeIcon, UploadIcon } from '../../../Components/icons';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { documentDelete, listDocuments } from '../../../services/bioplus-services/library';
import { useUserContext } from '../../../hooks/UserContext';
import DocumentView from './modals/docViewModal';
import DocumentUpload from './modals/docUploadModal';

const Library = () => {
  const [isUpload, setIsUpload] = useState();
  const [docInfo, setDocInfo] = useState(undefined);
  const [deleteDoc, setDeleteDoc] = useState(undefined);
  const userContext = useUserContext();
  const companyId = userContext?.company?.companyId?.id;

  const listOfDocuments = useQuery('listOfDocs', () => listDocuments(companyId));
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: (doc) => {
      return documentDelete(companyId, doc?._id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['listOfDocs'] });
      alert('Document deleted successfully.');
    },
    onError: (e) => {
      alert(e?.response?.data?.message);
    },
  });

  const handleDeleteDocument = (geofence) => {
    deleteMutation.mutate(geofence);
    setDeleteDoc(undefined);
  };

  //   table coulmns
  const docTableCols = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.doc.name" />,
        accessor: 'name',
        width: '21%',
      },
      {
        Header: <IntlMessages id="table.col.doc.type" />,
        accessor: 'contentType',
        width: '21%',
      },
      {
        Header: <IntlMessages id="table.col.doc.uploaded.by" />,
        accessor: 'createdBy',
        width: '25%',
      },
      {
        Header: <IntlMessages id="table.col.doc.created" />,
        accessor: 'createdAt',
        width: '20%',
        Cell: (cellData) => (
          <TableCell>
            {' '}
            {cellData.value ? moment(cellData.value).format('DD-MM-YYYY') : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.actions" />,
        accessor: 'actions',
        isAction: true,
        width: '20%',
      },
    ],
    []
  );

  const actionList = [
    (data) => (
      <IconButton onClick={() => setDocInfo(data)}>
        <EyeIcon style={{ width: '22px', height: '22px' }} />
      </IconButton>
    ),
    (data) => (
      <IconButton onClick={() => setDeleteDoc(data)}>
        <DeleteIcon style={{ width: '19px', height: '19px' }} />
      </IconButton>
    ),
  ];

  if (listOfDocuments.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.library" />
        </HeaderTitle>
        <IconButtonWithText
          text={<IntlMessages id="button.text.upload" />}
          icon={<UploadIcon />}
          onClick={() => {
            setIsUpload(true);
          }}
        />
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={listOfDocuments.data || []}
          columns={docTableCols}
          hasFooter={false}
          actions={actionList}
        />
      </TableWrapper>
      {docInfo && docInfo !== undefined && (
        <DocumentView onClose={() => setDocInfo(undefined)} companyId={companyId} data={docInfo} />
      )}
      {isUpload && <DocumentUpload onClose={() => setIsUpload(false)} companyId={companyId} />}
      {deleteDoc && (
        <DeleteConfirmationModal
          onClose={() => setDeleteDoc(undefined)}
          message={
            <IntlMessages id="doc.delete.confirmation" values={{ docName: deleteDoc.name }} />
          }
          onConfirm={() => handleDeleteDocument(deleteDoc)}
        />
      )}
    </StyledContainer>
  );
};

export default Library;
